/**
 * Reads a possibly-nested RHF error message by dotted path (e.g. `buyers.0.pep.parties.1.role`).
 * Used where a field path is only known as a string at render time (e.g. PepSection).
 */
export function getNestedFieldError(errors: unknown, path: string): string | undefined {
  const parts = path.split('.');
  let node: unknown = errors;
  for (const part of parts) {
    if (!node || typeof node !== 'object') return undefined;
    node = (node as Record<string, unknown>)[part];
  }
  const err = node as {message?: unknown; root?: {message?: unknown}} | null | undefined;
  const message = err?.message ?? err?.root?.message;
  return typeof message === 'string' ? message : undefined;
}
